(() => {
  'use strict';

  const language = (document.documentElement.lang || '').toLowerCase();
  if (!language.startsWith('en')) return;

  const exactTranslations = new Map([
    ['Zorgvuldig gekozen producten voor betere slaap, minder stress en meer dagelijks gemak voor jouw viervoeter.', 'Carefully selected products for better rest, greater comfort and more everyday convenience for your pet.'],
    ['4.8/5 beoordeeld door tevreden baasjes', '4.8/5 rated by happy pet parents'],
    ['4,8/5 beoordeeld door tevreden baasjes', '4.8/5 rated by happy pet parents'],
    ['Voor 17:00 besteld, morgen verzonden', 'Ordered before 5 PM, shipped the next business day'],
    ['Praktische tips, inspiratie en verzorgingsadvies voor een gezond en gelukkig huisdier.', 'Practical tips, inspiration and care advice for a healthy and happy pet.'],
    ['Verder lezen & ontdekken', 'Keep reading & exploring'],
    ['Nog meer tips voor je huisdier én producten die daarbij passen.', 'More tips for your pet and products to match.'],
    ['Ontdek meer blogtips of bekijk direct een passend Lucky4Voeter product.', 'Discover more blog tips or find a suitable Lucky4Voeter product right away.'],
    ['Naar het blogoverzicht', 'View all blog posts'],
    ['Meer Tips voor Je Huisdier', 'More Tips for Your Pet'],
    ['Naam', 'Name'],
    ['E-mailadres', 'Email address'],
    ['Telefoon (Optioneel)', 'Phone (optional)'],
    ['Telefoon (optional)', 'Phone (optional)'],
    ['Telefoon (Optional)', 'Phone (optional)'],
    ['Omschrijf je vraag of bericht', 'Describe your question or message'],
    ['Slimme oplossingen die bijdragen aan veiligheid, controle en gemoedsrust. Ontdek innovatieve producten die baasjes en huisdieren helpen zorgeloos op pad te gaan.', 'Smart solutions that support safety, control and peace of mind. Discover innovative products that help pets and their owners travel with confidence.'],
    ['Volg ons op', 'Follow us']
  ]);

  const fragmentTranslations = [
    ['Zorgvuldig gekozen producten voor betere slaap, minder stress en', 'Carefully selected products for better rest, greater comfort and'],
    ['meer dagelijks gemak voor jouw viervoeter.', 'more everyday convenience for your pet.'],
    ['beoordeeld door tevreden baasjes', 'rated by happy pet parents'],
    ['Voor 17:00 besteld,', 'Ordered before 5 PM,'],
    ['morgen verzonden', 'shipped the next business day'],
    ['Praktische tips, inspiratie en verzorgingsadvies', 'Practical tips, inspiration and care advice'],
    ['voor een gezond en gelukkig huisdier.', 'for a healthy and happy pet.'],
    ['Nog meer tips voor je huisdier én producten', 'More tips for your pet and products'],
    ['die daarbij passen.', 'to match.'],
    ['Slimme oplossingen die bijdragen aan veiligheid, controle en gemoedsrust. Ontdek', 'Smart solutions that support safety, control and peace of mind. Discover'],
    ['innovatieve producten die baasjes en huisdieren helpen zorgeloos op pad te gaan.', 'innovative products that help pets and their owners travel with confidence.']
  ];

  const translatableAttributes = ['placeholder', 'aria-label', 'title', 'value'];
  const normalize = (value) => (value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();

  function translateValue(value) {
    if (!value) return value;

    const leading = (value.match(/^\s*/) || [''])[0];
    const trailing = (value.match(/\s*$/) || [''])[0];
    const normalized = normalize(value);

    if (!normalized) return value;

    const exact = exactTranslations.get(normalized);
    if (exact) return `${leading}${exact}${trailing}`;

    let translated = normalized;
    for (const [source, target] of fragmentTranslations) {
      if (translated.includes(source)) {
        translated = translated.split(source).join(target);
      }
    }

    return translated === normalized ? value : `${leading}${translated}${trailing}`;
  }

  function translateTextNode(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE) return;
    const parent = node.parentElement;
    if (!parent || ['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA'].includes(parent.tagName)) return;

    const translated = translateValue(node.nodeValue || '');
    if (translated !== node.nodeValue) node.nodeValue = translated;
  }

  function mayTranslateValueAttribute(element) {
    if (element.tagName === 'BUTTON') return true;
    if (element.tagName !== 'INPUT') return false;
    return ['button', 'submit', 'reset'].includes((element.getAttribute('type') || '').toLowerCase());
  }

  function translateAttributes(element) {
    if (!(element instanceof Element)) return;

    for (const attribute of translatableAttributes) {
      if (!element.hasAttribute(attribute)) continue;
      if (attribute === 'value' && !mayTranslateValueAttribute(element)) continue;

      const original = element.getAttribute(attribute) || '';
      const translated = translateValue(original);
      if (translated !== original) element.setAttribute(attribute, translated);
    }
  }

  function translateSubtree(root) {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      translateTextNode(root);
      return;
    }

    if (!(root instanceof Element) && root !== document) return;

    if (root instanceof Element) translateAttributes(root);

    const textWalker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || ['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA'].includes(parent.tagName)) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    let textNode;
    while ((textNode = textWalker.nextNode())) translateTextNode(textNode);

    if (root.querySelectorAll) {
      root.querySelectorAll('[placeholder],[aria-label],[title],[value]').forEach(translateAttributes);
    }
  }

  function run() {
    if (document.body) translateSubtree(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  setTimeout(run, 250);
  setTimeout(run, 1000);

  const queuedNodes = new Set();
  let scheduled = false;

  function flush() {
    scheduled = false;
    const nodes = Array.from(queuedNodes);
    queuedNodes.clear();
    nodes.forEach(translateSubtree);
  }

  function queue(node) {
    if (node) queuedNodes.add(node);
    if (!scheduled && queuedNodes.size) {
      scheduled = true;
      window.requestAnimationFrame(flush);
    }
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(queue);
      } else if (mutation.type === 'characterData') {
        queue(mutation.target);
      } else if (mutation.type === 'attributes') {
        queue(mutation.target);
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: translatableAttributes
  });
})();